import { makeStyles } from '@material-ui/core';
import { CustomTheme } from "../../appTemplates/MUIProviderTemplate/MUIProviderTemplateInterfaces";

export const useSamplePhotoStyles = (
  isMobileView: boolean,
  numberOfSamples: number,
  backgroundUrl: string,
) =>
  makeStyles((theme: CustomTheme) => {
    const itemsPerRow = isMobileView ? Math.min(numberOfSamples, 3) : Math.min(numberOfSamples, 5);
    const margin = isMobileView ? '10px' : '20px';
    return {
      root: {
        boxSizing: 'border-box',
        position: 'relative',
        width: `calc((100% - ${margin} * (${itemsPerRow} - 1)) / ${itemsPerRow});`,
        height: 'auto',
        borderWidth: '5px',
        borderStyle: 'solid',
        marginBottom: `${margin}`,
        marginRight: `${margin}`,
        [`&:nth-child(${itemsPerRow}n)`]: {
          marginRight: 0,
        },
      },
      wrong: {
        borderColor: theme.palette.error.main,
      },
      correct: {
        borderColor: theme.palette.success.main,
      },
      image: {
        width: '100%',
        paddingBottom: 'calc(4 / 3 * 100%)',
        backgroundImage: `url('${backgroundUrl}')`,
        backgroundSize: 'cover',
        backgroundPosition: 'top',
        backgroundRepeat: 'no-repeat',
      },
      icon: {
        position: 'absolute',
        bottom: '3px',
        right: '3px',
      },
      wrongIcon: {
        color: theme.palette.error.main,
      },
      correctIcon: {
        color: theme.palette.success.main,
      },
    };
  });
